/**
 * JSON-stringify a value and base64-encode its UTF-8 bytes. Works in both
 * browsers and Node.js (no `Buffer`), producing the same output as
 * `Buffer.from(JSON.stringify(value)).toString('base64')`.
 */
export const encodeBase64Json = (value: unknown) => {
  const bytes = new TextEncoder().encode(JSON.stringify(value));
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
};
